
import { useEffect, useCallback, useState, useRef } from "react";
import axiosInstance from "../api/axiosInstance";
import { ENDPOINTS } from "../api/endpoints";

export const useDriverTracking = (taskId, enabled) => {
  const [driverData, setDriverData] = useState(null);
  const [driverPosition, setDriverPosition] = useState(null);
  const [remainingTime, setRemainingTime] = useState(null);
  const [totalTime, setTotalTime] = useState(null);
  const [acknowledgeTime, setAcknowledgeTime] = useState(null);

  const fetchDriver = useCallback(async () => {
    if (!taskId) return;

    // console.log(" Fetching driver data for taskId:", taskId);

    try {
      const res = await axiosInstance.post(
        ENDPOINTS.DRIVER_DETAILS,
        { taskId }
      );

      if (res?.data?.responseCode !== "00") return;

      const row = res.data.data;
      if (!row) return;

      setDriverData({
        name: row.driver_name,
        phone: row.diver_mobile_number,
        image: row.driver_image,
        driverID: row._driverCode,
      });

      if (
        row.drvier_latitude != null &&
        row.driver_longitude != null
      ) {
        setDriverPosition([
          Number(row.drvier_latitude),
          Number(row.driver_longitude),
        ]);
      }
    console.log("driverid", row._driverCode);


      setRemainingTime(
        row.remaining_time != null ? Number(row.remaining_time) : null
      );

      setTotalTime(
        row.total_time != null ? Number(row.total_time) : null
      );

      setAcknowledgeTime(row._acknowledgeTime || null);

      console.log(" Driver data fetched successfully");

    } catch (err) {
      console.error(" Driver detail error", err);
    }
  }, [taskId]);

  const fetchedRef = useRef(false);

  //  Reset when enabled becomes false
  useEffect(() => {
    if (!enabled) {
      // console.log(" Driver tracking disabled - Resetting ref");
      fetchedRef.current = false;
      // Optional: Clear data
      setDriverData(null);
      setDriverPosition(null);
      setRemainingTime(null);
      setTotalTime(null);
      setAcknowledgeTime(null);
      return;
    }

    if (fetchedRef.current) {
      // console.log(" Already fetched, skipping");
      return;
    }

    // console.log(" Fetching driver data (first time)");
    fetchedRef.current = true;
    fetchDriver();
  }, [enabled, fetchDriver]);

  return {
    driverData,
    driverPosition,
    remainingTime,
    totalTime,
    acknowledgeTime,
    refetchDriver: fetchDriver,
  };
};